import React from 'react';
import { ShiftProvider } from './shifts.context';
import { SingleShiftProvider } from './single-shift.context';
import { CreateShiftProvider } from './create-shift.context';

export function Context({ children }) {
  return (
    <ShiftProvider>
      <SingleShiftProvider>
        <CreateShiftProvider>{children}</CreateShiftProvider>
      </SingleShiftProvider>
    </ShiftProvider>
  );
}
